import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "./components/button";
import Slider from "./components/slider";
import { handleStagesBankMetrix } from "containers/services/data.transformers";

const BankCard = ({ currentStage, data, loading, onFinishCard }) => {
  const { t, metrixInstance } = useTranslation();
  const [revertCard, setRevertCard] = useState(false);
  const [activeSlide, setActiveSlide] = useState(null);

  const { description = "", page_info = [] } =
    data?.stages?.filter((item) => item.key === "CARD")[0] ?? {};

  const handleNextStep = () => {
    onFinishCard({
      card_name: page_info[activeSlide]?.infos?.filter(
        (i) => i.label === "name"
      )[0]?.value,
    });
  };

  const handleRevertedCard = () => {
    setRevertCard(!revertCard);
  };

  const onSlideChange = (e) => {
    setActiveSlide(e);
  };

  useEffect(() => {
    page_info.length === 1 ? setActiveSlide(0) : setActiveSlide(1);
  }, [page_info]);

  useMemo(async () => {
    await handleStagesBankMetrix("CARD", metrixInstance);
  }, [currentStage?.key]);

  return (
    <>
      <div className="flex  flex-col w-full sm:max-w-xl   fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2   overflow-auto ">
        <p className="body-14px-regular text-gray-4 m-4 text-center">
          {description}
        </p>
        <Slider
          activeSlide={activeSlide}
          data={page_info}
          handleRevertedCard={handleRevertedCard}
          revertCard={revertCard}
          onSlideChange={onSlideChange}
        />
        {/* <div className="mt-9 text-center">
          <p className="body-14px-regular text-gray-0">{description}</p>
        </div> */}
      </div>
      <Button
        loading={loading}
        name={t("card-page.choose")}
        onNextStep={handleNextStep}
      />
    </>
  );
};

export default BankCard;
